@for (item of result.items; track i; let i = $index) {
    <big-search-result-item
        [highlightString]="searchTerm"
        [item]="item"
        [bigSearchResultTracking]="{
            eventAction: 'search_result_click',
            clickRank: i + 1 + result.offset,
            clickTarget: item.url,
            currentPage
        }" />
} @empty {
    <div
        *transloco="let t; prefix: 'search'"
        class="container">
        <div class="grid grid-cols-12 gap-3">
            <div class="col-span-12 md:col-span-8 md:col-start-3">
                <h4>{{ t('notFound.title') }}</h4>
                <big-ui-list
                    [render]="'bullet'"
                    [items]="emptyResultList" />
            </div>
            <div class="col-span-12 mt-12 md:col-span-4 md:col-start-3">
                <img
                    src="assets/empty-search-results-placeholder.jpg"
                    class="rounded-md"
                    [alt]="t('notFound.imageAlt')" />
            </div>
            <div class="col-span-12 mt-4 md:col-span-4 md:mt-12">
                <h4>{{ t('notFound.contact.title') }}</h4>
                <p>{{ t('notFound.contact.text') }}</p>
                <p>
                    <a
                        href="tel:{{ servicePhoneNumber.number }}"
                        class="text-primary no-underline">
                        <strong>{{ servicePhoneNumber.title }}</strong>
                    </a>
                    <br />
                    {{ t('notFound.contact.hotline') }}
                </p>
                <p>
                    {{ t('notFound.contact.message') }}
                    <br />
                    <big-ui-link
                        [href]="t('notFound.contact.goTo.link')"
                        [linkClass]="'text-primary'">
                        {{ t('notFound.contact.goTo.text') }}
                    </big-ui-link>
                </p>
            </div>
        </div>
    </div>
}
